import Phaser from 'phaser'
import { HOME_SHOTS } from '../constants/assets-constants'

export default class Shot {
  /** @type Phaser.GameObjects.Sprite */
  Shot

  /**
   * @type {{
   * context: Phaser.Scene,
   * }}
   **/
  sceneContext = {}

  /**
   * @param {Phaser.Scene} context
   */
  constructor(context) {
    this.sceneContext = context
  }

  preload() {}

  create() {
    this.Shot = this.sceneContext.physics.add
      .sprite(
        this.sceneContext.toalla.x,
        this.sceneContext.toalla.y,
        this.getRamdomShot()
      )
      .setOrigin(0.5)
      .setBounce(1)
      .setInteractive()
      .setVelocity(0, 0)
      .setCollideWorldBounds(true)
    this.Shot.disableBody(true, true)
    this.Shot.body.setBoundsRectangle(
      new Phaser.Geom.Rectangle(
        this.sceneContext.plataforma.x,
        this.sceneContext.plataforma.y,
        this.sceneContext.plataforma.displayWidth,
        this.sceneContext.plataforma.displayHeight
      )
    )

    this.sceneContext.physics.add.collider(
      this.Shot,
      this.sceneContext.gotasRojas,
      this.hitShot,
      null,
      this.sceneContext
    )
  }

  hitShot(shot, gota) {
    shot.disableBody(true, true)
    gota.destroy()
  }

  getRamdomShot() {
    return Object.keys(HOME_SHOTS)[
      Math.floor(Math.random() * Object.keys(HOME_SHOTS).length)
    ]
  }
}
